function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4ZM14.6884 13.4318L15.4874 18.2598H16.5584L17.3404 13.4318V10.1338H14.6884V13.4318ZM14.8244 21.8298C15.0624 22.0791 15.4534 22.2038 15.9974 22.2038C16.5414 22.2038 16.9267 22.0791 17.1534 21.8298C17.3914 21.5805 17.5104 21.2745 17.5104 20.9118V20.5038C17.5104 20.1411 17.3914 19.8351 17.1534 19.5858C16.9267 19.3365 16.5414 19.2118 15.9974 19.2118C15.4534 19.2118 15.0624 19.3365 14.8244 19.5858C14.5977 19.8351 14.4844 20.1411 14.4844 20.5038V20.9118C14.4844 21.2745 14.5977 21.5805 14.8244 21.8298Z",
  fill: "#52AA55"
});

var SvgPositiveAlert = function SvgPositiveAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPositiveAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/positive_alert.4532f205.svg";
export { ForwardRef as ReactComponent };